var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 0 28 28",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#859AAD",
    d: "M6.723 5.48a5.251 5.251 0 1 1 8.265 4.802"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#859AAD",
    d: "M7.44 3.353a8.7 8.7 0 0 0 6.26 2.65 8.7 8.7 0 0 0 3.347-.666"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M10.823 9.753a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M4.823 7.175v1.078a3 3 0 0 0 3 3h1.423"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#859AAD",
    d: "M21.7 23.253a9.74 9.74 0 0 0-5.23-8.634M2.2 23.253a9.74 9.74 0 0 1 5.225-8.632"
  }))));
};
export default SvgSupport;